module.exports = __webpack_public_path__ + "img/it_seguromovil.408c4793.png";